import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  assetId: string;
  data: {
    name?: string;
    notes?: string;
    keywords?: string;
    meta?: Record<string, unknown>;
    colors?: unknown;
    url?: string;
  };
};

const [useSaveAssetMetadata, saveAssetMetadata] = createAsyncAction(
  "assets/saveMetadata",
  async ({ assetId, data }: Args) => {
    const res = await API.call<{ asset: string }>({
      endpoint: `assets/${assetId}`,
      method: "PUT",
      data,
    });
    return { ...res, result: res.result.asset };
  }
);

export default useSaveAssetMetadata;
export { saveAssetMetadata };
